import React, { useContext } from 'react';
import { WhiteDownArrow } from 'src/assets/images';
import { AccordionContext } from '../revamp-accordion/revamp-accordion';

export type RevampAccordionItemProps = {
  title: string;
  children: React.ReactNode;
  pill?: React.ReactElement;
  className?: String;
  onExpand?: () => void;
  index?: string;
};

const RevampAccordionItem = ({
  title,
  children,
  pill,
  className = '',
  onExpand,
  index,
}: RevampAccordionItemProps) => {
  const { active, setActive } = useContext(AccordionContext);

  const onClick = (title: string, index?: string) => {
    if (index !== undefined && index !== null) {
      setActive(active === index ? null : index);
    } else {
      setActive(active === title ? null : title);
    }

    if (onExpand) {
      onExpand();
    }
  };

  const isActive = (title: string, index?: string) => {
    if (index !== undefined && index !== null) {
      return active === index;
    }
    return active === title;
  };

  return (
    <li className={`flex flex-col w-full px-4 ${className} ${!!className ? 'li-address' : ''}`}>
      <div
        className={`flex items-center w-full p-4 cursor-pointer h-18 bg-grey-800 rounded-5 ${
          !!className ? 'header' : ''
        }`}
        onClick={() => onClick(title, index)}
      >
        <h6 className={`xs:mr-2 text-lg md:mr-8 ${pill && 'w-32 md:w-64'}`}>{title}</h6>
        {pill}
        <img
          className={`h-6 w-6 ml-auto ${isActive(title, index) ? 'rotate-180' : ''}`}
          src={WhiteDownArrow}
          alt="arrow"
        />
      </div>

      <div
        className={`${
          isActive(title, index) ? 'flex' : 'hidden'
        } px-6 py-4 bg-grey-800 flex-col gap-y-2 rounded-5 border-t-4 border-solid border-grey-900 ${
          !!className ? 'body' : ''
        }`}
      >
        {children}
      </div>
    </li>
  );
};

export default RevampAccordionItem;
